import { Stack, Table, Text } from '@mantine/core';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { SamplerCoverageMetricText } from './sampler-coverage-metric-text';

export type GpSurfacesContextTableRow = {
  key: string;
  label: string;
  value: ReactNode;
  emphasize?: boolean;
};

type GpSurfacesContextTableProps = {
  rows: GpSurfacesContextTableRow[];
  title?: string;
  muted?: boolean;
};

export const GpSurfacesContextTable: FC<GpSurfacesContextTableProps> = ({
  rows,
  title,
  muted,
}) => {
  const { t } = useTranslation();

  return (
    <Stack gap={4}>
      <Text
        c={muted ? 'dimmed' : undefined}
        fw={600}
        size={muted ? 'sm' : undefined}
      >
        {title ?? t('surfacesMap.tables.contextSection')}
      </Text>
      <Table
        horizontalSpacing="sm"
        layout="fixed"
        verticalSpacing={6}
        withTableBorder
      >
        <Table.Tbody>
          {rows.map((row) => (
            <Table.Tr key={row.key}>
              <Table.Td c="dimmed" w="55%">
                <Text size="sm">{row.label}</Text>
              </Table.Td>
              <Table.Td ta="right">
                {typeof row.value === 'string' || typeof row.value === 'number' ? (
                  <SamplerCoverageMetricText
                    fw={row.emphasize ? 700 : 600}
                    size={row.emphasize ? 'md' : 'sm'}
                    value={String(row.value)}
                  />
                ) : (
                  row.value
                )}
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Stack>
  );
};
